import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["applicationId", "campaignUrl", "label", "isStudio"],
  _excluded2 = ["renderFallbackComponent"];
import { useCallback, useMemo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SENTRY_KEYS } from 'campaigns-lib/constants/sentry';
import { UsageTracker } from '../utils/usageTracker';
import ErrorBoundary from './error/ErrorBoundary';
import useGetBackToCampaignParams from '../hooks/useGetBackToCampaignParams';
import { jsx as _jsx } from "react/jsx-runtime";
function BackToCampaignLinkComponent(_ref) {
  let {
      applicationId,
      campaignUrl,
      label,
      isStudio
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleOnClick = useCallback(() => {
    UsageTracker.track('backToCampaignLink', {
      action: 'back link clicked',
      applicationId
    });
  }, [applicationId]);
  const sharedProps = useMemo(() => {
    return {
      'data-test-id': 'back-to-campaign-link',
      href: campaignUrl,
      onClick: handleOnClick
    };
  }, [campaignUrl, handleOnClick]);
  const text = useMemo(() => {
    return label || /*#__PURE__*/_jsx(FormattedMessage, {
      message: isStudio ? 'backToCampaignLink.defaultStudio' : 'backToCampaignLink.default'
    });
  }, [label, isStudio]);
  if (props.use === 'button') {
    return /*#__PURE__*/_jsx(Button, Object.assign({}, props.buttonProps, sharedProps, {
      children: text
    }));
  }
  if (props.use === 'breadcrumbsLink') {
    return /*#__PURE__*/_jsx(Breadcrumbs, Object.assign({
      paddingInline: "0",
      marginBlock: "0"
    }, props.breadCrumbsProps, {
      children: /*#__PURE__*/_jsx(Link, Object.assign({}, props.linkProps, sharedProps, {
        children: text
      }))
    }));
  }
  return /*#__PURE__*/_jsx(BackButton, Object.assign({}, props.backButtonProps, {
    children: /*#__PURE__*/_jsx(Link, Object.assign({}, props.linkProps, sharedProps, {
      children: text
    }))
  }));
}
export default function BackToCampaignLink(_ref2) {
  let {
      renderFallbackComponent
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    fromCampaignId,
    fromStudioCampaignId
  } = useGetBackToCampaignParams();
  if (!fromCampaignId && !fromStudioCampaignId) {
    return renderFallbackComponent();
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    renderFallback: renderFallbackComponent,
    sentryKey: SENTRY_KEYS.BACK_TO_CAMPAIGN_LINK_FAILED,
    children: /*#__PURE__*/_jsx(BackToCampaignLinkComponent, Object.assign({}, props, {
      isStudio: !!fromStudioCampaignId,
      campaignUrl: fromStudioCampaignId ? `/marketing/${PortalIdParser.get()}/studio/${fromStudioCampaignId}` : `/marketing/${PortalIdParser.get()}/campaigns/${fromCampaignId}`
    }))
  });
}